<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ title }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <div class="field-row">
      <div class="field"><span class="field-label">Name</span><input class="text-box-active" formControlName="name" /></div>
      <div class="field">
        <span class="field-label">Status</span>
        <select class="text-box-active" formControlName="status">
          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
        </select>
      </div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Description</span><input class="text-box-active" formControlName="description" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Address</span><input class="text-box-active" formControlName="address" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Contact number</span><input class="text-box-active" type="number" formControlName="contactNumber" /></div>
      <div class="field"><span class="field-label">Alternate contact</span><input class="text-box-active" type="number" formControlName="altContactNumber" /></div>
    </div>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Cancel</button>
    <button type="button" class="ac-primary-btn" (click)="submit()">{{ isEdit ? 'Save' : 'Add' }}</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
